import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PaginatorIntlUtil } from './paginator-intl/paginator-intl.util';
import { PAGE_SIZE_OPTIONS } from './table-pagination.constants';

@Component({
  selector: 'app-table-pagination',
  templateUrl: './table-pagination.component.html',
  styleUrl: './table-pagination.component.scss',
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorIntlUtil }],
  standalone: false,
})
export class TablePaginationComponent implements AfterViewInit {
  @Input({ required: true }) datasource!: MatTableDataSource<any, MatPaginator>;
  @Input() pageIndex = 0;
  @Input() pageSize = 50;
  @Input() paginatorLength = 100;
  @Input() pageSizeOptions = PAGE_SIZE_OPTIONS;
  @Input() showFirstLastButtons = true;
  @Input() hidePageSize = false;
  @ViewChild('paginator') paginator!: MatPaginator;

  readonly window = window;

  ngAfterViewInit(): void {
    this.datasource.paginator = this.paginator;
  }
}
